import { useMemo, useState, useCallback } from "react";
import { useQuery } from "react-query";
import moment from "moment";
import { CalendarCustomToolbarWithoutViewSelection } from "components";
import StaffAvailabilityModal from "./StaffAvailabilityModal";
import { useReducer } from "react";
import { Calendar } from "react-big-calendar";
import { initialModalState, modalActions, modalReducer } from "./reducers";
import { momentLocalizer } from "react-big-calendar";
import { buildDateTime, firstDay, lastDay } from "utils/dateHelper";
import apiService from "services/api";
import { useWindowDimensions } from "utils/useWindowDimensions";
import { Button } from "reactstrap";
import NewAvailabilityModal from "./NewAvailabilityModal";
import { tConv24 } from "utils/dateHelper";

const localizer = momentLocalizer(moment);

const AvailabilityPage = () => {
	const [queryDateRange, setQueryDateRange] = useState({
		start: firstDay(),
		end: lastDay(),
	});
	const { width: windowWidth } = useWindowDimensions();
	const [view] = useState(windowWidth < 768 ? "day" : "month");
	const [currDate, setCurrDate] = useState(new Date());
	const handleNavigate = useCallback(
		(date) => {
			let [start, end] = [firstDay(date, "month"), lastDay(date, "month")];
			setCurrDate(date);
			const newStart = moment(start).unix();
			const newEnd = moment(end).unix();
			const currStart = moment(queryDateRange.start).unix();
			const currEnd = moment(queryDateRange.end).unix();
			if (newStart >= currStart && newEnd <= currEnd) {
				return;
			}
			return setQueryDateRange({ start, end });
		},
		[queryDateRange]
	);
	const { data: events, refetch } = useQuery(
		["availability", "self", queryDateRange.start, queryDateRange.end],
		() =>
			apiService.staff.availability
				.self({
					date_from: queryDateRange.start,
					date_to: queryDateRange.end,
				})
				.then((staffAvailabilities) =>
					staffAvailabilities.map((staffAvailability) => ({
						title: `${tConv24(staffAvailability.startTime)} - ${tConv24(staffAvailability.endTime)}`,
						start: buildDateTime(staffAvailability.date, staffAvailability.startTime),
						end: buildDateTime(staffAvailability.date, staffAvailability.endTime),
						allDay: false,
						color: "green",
						staffAvailability,
					}))
				),
		{ refetchOnWindowFocus: (query) => query.isFetching }
	);

	const [viewAvailabilityModalProps, dispatchViewAvailabilityModal] = useReducer(modalReducer, initialModalState);
	const [newAvailabilityModalProps, dispatchNewAvailabilityModal] = useReducer(modalReducer, initialModalState);

	const displayAvailabilityModal = (event) => {
		dispatchViewAvailabilityModal({ type: modalActions.OPEN, payload: event });
	};

	const displayNewAvailabilityModal = (event) => {
		dispatchNewAvailabilityModal({ type: modalActions.OPEN, payload: event });
	};

	return (
		<div className="content">
			<Button color="info" onClick={displayNewAvailabilityModal}>
				New Availabilty
			</Button>
			<NewAvailabilityModal state={newAvailabilityModalProps} dispatch={dispatchNewAvailabilityModal} refetch={refetch} />
			<StaffAvailabilityModal state={viewAvailabilityModalProps} dispatch={dispatchViewAvailabilityModal} refetch={refetch} />
			<Calendar
				selectable
				localizer={localizer}
				longPressThreshold={200}
				events={useMemo(() => events || [], [events])}
				defaultView="month"
				defaultDate={new Date()}
				eventPropGetter={() => ({ className: "event-green" })}
				onSelectEvent={displayAvailabilityModal}
				dayLayoutAlgorithm="no-overlap"
				date={useMemo(() => currDate, [currDate])}
				components={{
					toolbar: CalendarCustomToolbarWithoutViewSelection,
				}}
				onNavigate={handleNavigate}
				view={view}
				popup
				messages={{
					showMore: (total) => (
						<div
							style={{ cursor: "pointer" }}
							className="text-center"
							onMouseOver={(e) => {
								e.preventDefault();
							}}
						>
							{`+${total}`}
						</div>
					),
				}}
			/>
		</div>
	);
};

export default AvailabilityPage;
